export default __webpack_public_path__ + "static/media/AlertVectorRed.931b5c2d.svg";